import { Component, inject } from '@angular/core';

import { AuthService } from '../../../authentication/_services/auth.service';

@Component({
  selector: 'app-access-denied',
  standalone: false,
  templateUrl: './access-denied.component.html',
  styleUrl: './access-denied.component.scss'
})
export class AccessDeniedComponent {
  private authService = inject(AuthService);

  /** Send the user back to their own home - Logs for the ApplicationSupport login, the dashboard for officers. */
  isSupport = this.authService.homeRoute === '/logs';
}
